import React from "react";
import Link from "helpers/link";
import AnnouncementBarSlider from "./slider";
import Image from "components/image";
import { useSelector } from "react-redux";
import { getRgba } from "helpers/get-rgba";

const AnnouncementBar = ({ data }) => {
	const { enabled, text, url, txtColor, bgColor, slider, enableAnnouncementBarSlider, icon, subscriberSlider } = data;
	const { subscriptionId } = useSelector((state) => state.account.subscription);
	const announcmentBarData = subscriptionId && subscriberSlider ? subscriberSlider : slider;

	return enableAnnouncementBarSlider ? <AnnouncementBarSlider data={announcmentBarData} bgColor={bgColor} txtColor={txtColor} /> : (
		enabled && (
			<Link to={url ?? ""}>
				<div
					style={{
						backgroundColor: getRgba(bgColor),
						color: getRgba(txtColor),
					}}
					className="py-2.5 w-full text-center p-2 tracking-widest flex items-center justify-center"
				>				<div className="w-6 h-6 mr-2">
						<Image image={icon} alt={icon?.alt} />
					</div><p dangerouslySetInnerHTML={{ __html: text }} /></div>
			</Link>
		)
	);
};

export default AnnouncementBar;
